export default {
	advisoriesCount: '{count} advisories',
	completedOn: 'Vehicle MOT check completed on {date}.',
	disclaimer: 'Please complete your own vehicle MOT advisory checks at your discretion.',
	title: 'MOT advisories',
};
